import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";

const Contact = () => {
    return (
        <Container className="py-5">
            <Row className="mb-4 text-center">
                <Col>
                    <h2 className="fw-bold text-primary">Contact Us</h2>
                    <p className="text-muted">
                        Have questions, news tips, or feedback? We'd love to hear from you.
                    </p>
                </Col>
            </Row>

            <Row>
                {/* Contact Form */}
                <Col md={7}>
                    <Card className="shadow-sm p-4">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter your name" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control type="email" placeholder="Enter your email" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control type="text" placeholder="Enter subject" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Message</Form.Label>
                                <Form.Control as="textarea" rows={4} placeholder="Write your message..." />
                            </Form.Group>

                            <Button variant="primary" type="submit">
                                Send Message
                            </Button>
                        </Form>
                    </Card>
                </Col>

                {/* Contact Info */}
                <Col md={5}>
                    <Card className="shadow-sm p-4">

                        <p className="text-muted mb-1">📍Head Office: 1st Floor, Shalin Centrum, Nr. Croma, Sector 11, Gandhinagar.</p>
                        <p className="text-muted mb-1">📞 +91 8000930590</p>
                        <p className="text-muted">✉ proudtapi@gmail.com</p>

                        <hr />

                        <h6 className="fw-bold">Working Hours</h6>
                        <p className="text-muted mb-1">Mon - Sat: 9:00 AM - 6:00 PM</p>
                        {/* <p className="text-muted">Sat: 10:00 AM - 4:00 PM</p> */}
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;